// extracted by mini-css-extract-plugin
module.exports = {"slide":"slide_slide__MaPs3","picture":"slide_picture__N8A5o"};